import { render, staticRenderFns } from "./fullPageShell.vue?vue&type=template&id=6f8c7e56&scoped=true"
import script from "./fullPageShell.vue?vue&type=script&lang=js"
export * from "./fullPageShell.vue?vue&type=script&lang=js"
import style0 from "./fullPageShell.vue?vue&type=style&index=0&id=6f8c7e56&prod&scoped=true&lang=scss"
import style1 from "./fullPageShell.vue?vue&type=style&index=1&id=6f8c7e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8c7e56",
  null
  
)

export default component.exports